<template>
    <div class="betslip-selection__list betslip-selection__list--lotto">
        <div class="betslip-selection__list-wrapper">
            <div class="betslip-selection__item">
                <div class="selection-row">
                    <div class="selection-row__wrapper">
                        <LottoHeading
                            v-bind="eventDescription"
                        />
                        <transition-group
                            tag="div"
                            name="animation-list__spin-in-"
                            class="lotto-event__ball-grid"
                        >
                            <LottoBetSlipBall
                                v-for="(number, i) in selected"
                                :key="number"
                                :number="number"
                                :class="ballStatus(i)"
                                @removeNumberClick="onRemoveNumber"
                            />
                        </transition-group>
                    </div>
                </div>
            </div>
        </div>
        <LottoSystems
            :systems="systems"
            @systemClick="onSystemClick"
        />
    </div>
</template>

<script>
    import LottoHeading from '@modules/lotto/shared/LottoHeading.vue';
    import { EventStatus } from '@core/models/tickets/enums';
    import LottoSystems from './LottoSystems.vue';
    import LottoBetSlipBall from './LottoBetSlipBall.vue';

    export default {
        name: 'LottoBetSlip',
        props: {
            selected: {
                type: Array,
                required: true
            },
            selectionStatuses: {
                type: Array,
                default: null,
            },
            eventDescription: {
                type: Object,
                required: true,
            },
            systems: {
                type: Array,
                required: true
            },
            eventNo: {
                type: String,
                required: false,
                default: ''
            }
        },
        methods: {
            onRemoveNumber(number) {
                this.$emit('removeNumberClick', number);
            },
            onSystemClick(system) {
                this.$emit('systemClick', system);
            },
            ballStatus(index) {
                if (this.selectionStatuses) {
                    switch (this.selectionStatuses[index]) {
                        case EventStatus.win:
                            return 'ball-grid__ball-wrapper--won';
                        case EventStatus.lost:
                            return 'ball-grid__ball-wrapper--lost';
                        case EventStatus.refund:
                            return 'ball-grid__ball-wrapper--refund';
                        default:
                            return '';
                    }
                }
                return '';
            }
        },
        components: {
            LottoBetSlipBall,
            LottoSystems,
            LottoHeading,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/lotto/betSlip/LottoBetSlip.vue